import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=2025051c&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2025051c', component.options)
    } else {
      api.reload('2025051c', component.options)
    }
    module.hot.accept("./BaseImage.vue?vue&type=template&id=2025051c&", function () {
      api.rerender('2025051c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseImage.vue"
export default component.exports